<template>
  <page-header-wrapper>
    <a-card>
      <div class="spin-load" v-if="!showData">
        <a-spin :spinning="!showData"></a-spin>
      </div>
      <div class="app-container" v-if="showData">
        <a-form ref="form" :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="返佣比例" class="margin-bottom-10">
            <a-input v-model="form.commissionRate" placeholder="请输入返佣比例" allow-clear style="width: 300px">
              <template #suffix>%</template>
            </a-input>
            <span class="tip">(用户发帖种草带来的订单返佣比例，不能大于100%小于0%)</span>
          </a-form-item>
          <a-form-item label="启用状态" class="margin-bottom-10">
            <a-radio-group v-model="form.status" button-style="solid">
              <a-radio-button :value="1">启用</a-radio-button>
              <a-radio-button :value="0">禁用</a-radio-button>
            </a-radio-group>
            <span class="tip">(禁用后新订单不再计算返佣，已有返佣记录不受影响)</span>
          </a-form-item>
          <a-row class="margin-top-xl">
            <a-col :span="4"></a-col>
            <a-col :span="8">
              <a-button size="large" type="primary" :loading="loading" :disabled="loading" @click="onSubmit" style="width:200px">
                确定
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getGrassCommissionConfig, saveGrassCommissionConfig } from '@/api/grassCommission'

export default {
  name: 'GrassCommission',
  data() {
    return {
      showData: false,
      loading: false,
      form: {
        commissionRate: 0,
        id: null,
        status: 1
      }
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      this.showData = false
      getGrassCommissionConfig().then(res => {
        if (res.success && res.data) {
          this.form.id = res.data.id
          this.form.commissionRate = res.data.commissionRate
          this.form.status = res.data.status
        } else {
          this.form.commissionRate = 5
          this.form.status = 1
        }
        this.showData = true
      }).catch(() => {
        this.form.commissionRate = 5
        this.form.status = 1
        this.showData = true
      })
    },
    onSubmit() {
      const rate = Number(this.form.commissionRate)
      if (rate > 100 || rate < 0) {
        this.$message.error('返佣比例不能大于100%小于0%')
        return
      }
      this.loading = true
      saveGrassCommissionConfig({
        id: this.form.id,
        commissionRate: rate,
        status: Number(this.form.status)
      }).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.tip {
  line-height: 20px !important;
  font-size: 12px;
  margin-left: 10px;
}
.margin-bottom-10 {
  margin-bottom: 10px !important;
}
.spin-load {
  text-align: center;
}
.margin-top-xl {
  margin-top: 24px;
}
</style>
